import { Products } from '../models/order-details';
import { OrderFlowState, OrderFlow } from '../redux/orderFlow/orderFlowSlice';
import { parseDateSafely } from '../components/atoms/date-picker/date-picker-functions';
import { differenceInMonths, differenceInDays, differenceInCalendarDays } from 'date-fns';

export const getMonthsNumber = (returnDate: string, departureDate: string): number => {
  const departureObj = parseDateSafely(departureDate);
  const returnObj = parseDateSafely(returnDate);
  
  if (!departureObj || !returnObj) return 0;
  
  const monthsDiff = differenceInMonths(returnObj, departureObj);
  
  const testDate = new Date(returnObj);
  testDate.setUTCMonth(departureObj.getUTCMonth() + monthsDiff);
  
  if (returnObj.getTime() >= testDate.getTime()) {
    return monthsDiff + 1;
  }
  
  return monthsDiff <= 0 ? 0 : monthsDiff;
};

export const hasProduct = (Order: OrderFlowState, productId: string) => {
  return Order.orderedProducts && Order.orderedProducts.includes(productId);
};

export function setProductEnumAsString(order: OrderFlowState): string {
  let selectedProduct = Products.Main;
  const hasSports = hasProduct(order, 'SPORTS2024');
  const hasHolidays = hasProduct(order, 'TRAVEL2024');
  const hasHealth = hasProduct(order, 'MAIN2024');

  if (order.flow === OrderFlow.Flow1) {
    if (hasSports && hasHolidays) {
      selectedProduct = Products.MainSportsHolidays;
    } else if (hasSports) {
      selectedProduct = Products.MainSports;
    } else if (hasHolidays) {
      selectedProduct = Products.MainHolidays;
    }
  } else if (order.flow === OrderFlow.Flow2) {
    if (hasSports && hasHolidays) {
      selectedProduct = Products.SportsHolidays;
    } else if (hasSports) {
      selectedProduct = Products.Sports;
    } else if (hasHolidays) {
      selectedProduct = Products.Holidays;
    }
  }

  return selectedProduct.toString();
}

export const getDaysNumberCommercial = (returnDate: string, departureDate: string): number => {
  if (!returnDate || !departureDate) return 0;
  
  const departureObj = parseDateSafely(departureDate);
  const returnObj = parseDateSafely(returnDate);
  
  if (!departureObj || !returnObj) return 0;
  
  const daysDiff = differenceInCalendarDays(returnObj, departureObj);
  
  return daysDiff + 1;
};
